<template>
  <!-- Design: FilterChip — a chosen filter with its remove button -->
  <span class="filter-tag" :class="{ 'ts-filter-tag-editable': editable }" @click="editable && $emit('edit')">
    {{ label }}
    <button class="filter-tag-remove" type="button" :aria-label="`${removeText}: ${label}`" @click.stop="$emit('remove')">
      <svg class="filter-tag-x" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 3l6 6M9 3l-6 6"></path></svg>
    </button>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component
export default class TsFilterChip extends Vue {
  @Prop({ required: true }) readonly label!: string;

  // Clicking the chip itself (not the ×) reopens the choice it stands for
  @Prop({ type: Boolean, default: false }) readonly editable!: boolean;

  get removeText() {
    return AppModule.translation[5285];
  }
}
</script>
